/*!
 * devextreme-vue
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-vue
 */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEMPLATE_MULTIPLE_ROOTS_ERROR = "Template must have a single root node.";



//////////////////
// WEBPACK FOOTER
// ./node_modules/devextreme-vue/core/errors.js
// module id = ryvK
// module chunks = 0